import { AbgwMigrationsSummary } from '@schema';
import useAbgwUpstreamsStore from '@/common/store/pinia/abgwUpstreams';

export type AbgwMigrationsSummaryRaw = AbgwMigrationsSummary & { id: string };

const abgwMigrationsMapper = (item: AbgwMigrationsSummaryRaw) => {
  const upstreamsStore = useAbgwUpstreamsStore();
  const getAddress = (dcUid: string) => upstreamsStore.getItemById(dcUid)?.address ?? dcUid;

  return {
    ...item,
    src_upstream: getAddress(item.src_upstream),
    dst_upstream: getAddress(item.dst_upstream)
  };
};

export type AbgwMigrationsSummaryItem = ReturnType<typeof abgwMigrationsMapper>;

export default abgwMigrationsMapper;
